export default __webpack_public_path__ + "static/media/Monitoramento (Real Size).8fa70dda.svg";